<template>
    <div>
        <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="4000"
          controls
          indicators
          background="#ababab"
          img-width="1024"
          img-height="724"
          style="text-shadow: 1px 1px 2px #333"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <b-carousel-slide
            :img-src="require('@/assets/business_slide1.png')"
          ></b-carousel-slide>

          <b-carousel-slide
            :img-src="require('@/assets/business_slide2.png')"
          ></b-carousel-slide>

          <b-carousel-slide
            :img-src="require('@/assets/business_slide3.png')"
          ></b-carousel-slide>
        </b-carousel>
      </div>
</template>

<script>
    export default {
      data() {
        return {
          slide: 0,
          sliding: null,
        };
      },
      methods: {
        onSlideStart() {
          this.sliding = true;
        },
        onSlideEnd() {
          this.sliding = false;
        },
      },
    };
    </script>